import { render, staticRenderFns } from "./NotificationCount.vue?vue&type=template&id=bd0288de&"
import script from "./NotificationCount.vue?vue&type=script&lang=js&"
export * from "./NotificationCount.vue?vue&type=script&lang=js&"
import style0 from "./notification-count.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports